const initialState = {
  selectedElements: [],
  filterType: "elements",
  formulaSearchTerm: "",
  productsFetched: [],
	productsSorted: [],
  productsLoading: false,
  productsSortedBy: "relevance",
	availableElements: [],
  availableWithSelectedElements: [],
	isSearchPerformed: false
};

export default initialState;
